export const MenuItems = [
  {
    title: 'Overview',
    path: '/about',
    cName: 'dropdown-link'
  },
  {
    title: 'Articles',
    path: '/articles',
    cName: 'dropdown-link'
  },
  {
    title: 'Gallery',
    path: '/gallery',
    cName: 'dropdown-link'
  },
  {
    title: 'Team',
    path: '/team',
    cName: 'dropdown-link'
  }
];
